var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50257 0.0979415C1.2015 -0.0595442 0.843628 -0.0268584 0.573804 0.184113C0.303981 0.395084 0.173329 0.748684 0.232974 1.09337L2.00813 10.3791C2.06494 10.7119 2.29216 10.9853 2.60174 11.0952L6.28839 12.9999L2.60174 14.9046C2.295 15.0115 2.06778 15.2879 2.00813 15.6207L0.232974 24.9064C0.173329 25.2511 0.303981 25.6047 0.573804 25.8157C0.843628 26.0266 1.2015 26.0593 1.50257 25.9018L24.5796 13.8319C24.8807 13.6744 25.071 13.3535 25.071 13.0029C25.071 12.6522 24.8807 12.3283 24.5796 12.1738L1.50257 0.0979415Z",
    fill: "#81828D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBtn);
export default __webpack_public_path__ + "static/media/send-btn.b3529e77c5f8eae10caf78ac8d7f1735.svg";
export { ForwardRef as ReactComponent };